import React from 'react';
import './pagination.style.scss';
import { PaginationProps } from './pagination.interface';
import { connect, ConnectedProps } from 'react-redux';
import { Direction, ReduxState } from 'interface';

const PaginationComponent: React.FC<PaginationProps & ConnectedProps<typeof connector>> = function (
    props: PaginationProps & ConnectedProps<typeof connector>,
) {
    const totalPages = props.totalPages;
    const activePage = props.activePage;
    let pages: (number | string)[] = [];
    if (totalPages === 1) {
        return null;
    }
    if (totalPages > 7) {
        if (activePage < 4) pages = [1, 2, 3, 4, 5, '...', totalPages];
        else if (activePage > totalPages - 4)
            pages = [1, 2, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
        else pages = [1, '...', activePage - 1, activePage, activePage + 1, '...', totalPages];
    } else
        for (let i = 1; i < totalPages + 1; i++) {
            pages[i] = i;
        }

    return (
        <div className="ucheck-pagination">
            <div>
                <i
                    className={`pre-page-arrow material-icons${activePage === 1 ? ' disable' : ''}`}
                    onClick={() => {
                        if (1 !== activePage && props.onPageChange) props.onPageChange(activePage - 1);
                    }}
                >
                    chevron_{props.direction === Direction.rtl ? 'right' : 'left'}
                </i>
                <div className="page-numbers">
                    {pages.map((item, key) => (
                        <span
                            key={key}
                            className={`${item === activePage ? 'active' : ''}`}
                            onClick={() => {
                                if (props.onPageChange) {
                                    if (typeof item === 'number') {
                                        props.onPageChange(item);
                                    } else if (key < 4) {
                                        props.onPageChange(props.activePage - 1);
                                    } else {
                                        props.onPageChange(props.activePage + 1);
                                    }
                                }
                            }}
                        >
                            {item}
                        </span>
                    ))}
                </div>
                <i
                    className={`pre-page-arrow material-icons${activePage === totalPages ? ' disable' : ''}`}
                    onClick={() => {
                        if (totalPages !== activePage && props.onPageChange) props.onPageChange(activePage + 1);
                    }}
                >
                    chevron_{props.direction === Direction.rtl ? 'left' : 'right'}
                </i>
            </div>
        </div>
    );
};
const mapStateToProps = (state: ReduxState) => ({
    direction: state.direction,
});

const connector = connect(mapStateToProps);
export default connector(PaginationComponent);
